import { dimensions, SvgIconProps } from "./SvgIcon";

export const BookClosedIcon = (props: SvgIconProps & { filled?: boolean }) => {
  const { width, height } = dimensions(props);
  return (
    <svg
      width={width}
      height={height}
      style={{
        ...props.style,
        ...(props.disabled ? { opacity: 0.3 } : {}),
      }}
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3334 12.6668V10.6668H2.66675C1.56218 10.6668 0.666748 11.5623 0.666748 12.6668M3.86675 14.6668H9.20008C9.94682 14.6668 10.3202 14.6668 10.6054 14.5215C10.8563 14.3937 11.0603 14.1897 11.1881 13.9388C11.3334 13.6536 11.3334 13.2802 11.3334 12.5335V3.46683C11.3334 2.72009 11.3334 2.34672 11.1881 2.06151C11.0603 1.81063 10.8563 1.60665 10.6054 1.47882C10.3202 1.3335 9.94682 1.3335 9.20008 1.3335H3.86675C2.74664 1.3335 2.18659 1.3335 1.75877 1.55148C1.38244 1.74323 1.07648 2.04919 0.884735 2.42552C0.666748 2.85334 0.666748 3.41339 0.666748 4.5335V11.4668C0.666748 12.5869 0.666748 13.147 0.884735 13.5748C1.07648 13.9511 1.38244 14.2571 1.75877 14.4488C2.18659 14.6668 2.74664 14.6668 3.86675 14.6668Z"
        stroke={"currentColor"}
        strokeWidth="1.2"
        fill={props.filled ? "currentColor" : "transparent"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
